import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import { Sparkle, ArrowRight, Check } from "@phosphor-icons/react";

export function VoiceIntroStep({ onStart, onBack }) {
  return (
    <motion.div key="intro" initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} exit={{ opacity: 0, y: -20 }} className="space-y-8" data-testid="voice-wizard-intro">
      <button onClick={onBack} className="flex items-center gap-1.5 text-sm text-[var(--text-muted)] hover:text-[var(--text-primary)] transition-colors" data-testid="back-to-settings">
        <Sparkle size={16} /> Back to Settings
      </button>

      <div className="text-center space-y-4 py-8">
        <div className="w-16 h-16 rounded-2xl bg-[#FF4400]/10 flex items-center justify-center mx-auto">
          <Sparkle size={32} className="text-[#FF4400]" weight="duotone" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-bold text-[var(--text-primary)] font-['Cormorant_Garamond']" data-testid="wizard-heading">
          Let's capture your brand voice.
        </h1>
        <p className="text-base text-[var(--text-secondary)] max-w-lg mx-auto leading-relaxed">
          Paste in 2-3 examples of content that sounds like you at your best. This could be emails you've written, social posts, a bio, a sales page — anything that feels authentically yours.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 gap-4 max-w-md mx-auto">
        <div className="flex items-start gap-3 p-4 rounded-lg bg-[var(--bg-card)] border border-[var(--border)]">
          <Check size={18} className="text-emerald-400 mt-0.5 shrink-0" weight="bold" />
          <p className="text-sm text-[var(--text-secondary)]">More specific examples = more accurate voice</p>
        </div>
        <div className="flex items-start gap-3 p-4 rounded-lg bg-[var(--bg-card)] border border-[var(--border)]">
          <Check size={18} className="text-emerald-400 mt-0.5 shrink-0" weight="bold" />
          <p className="text-sm text-[var(--text-secondary)]">Client content works too — just make sure it reflects your style</p>
        </div>
      </div>

      <div className="flex justify-center pt-4">
        <Button onClick={onStart} className="bg-[#FF4400] hover:bg-[#FF6633] text-white px-8 h-11 text-sm font-semibold" data-testid="start-wizard-btn">
          Start <ArrowRight size={16} className="ml-2" />
        </Button>
      </div>
    </motion.div>
  );
}
